export default __webpack_public_path__ + "static/media/Wind of the Vanir.9e9e856b.jpg";